import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

// bayclubs modules
import { UtilsModule } from '@bayclubs/utils';

//clients
import { ApiHttpClient } from './services/api-http-client';
import { CouponsHttpClient } from './services/coupons-http-client';

//services

//components

@NgModule({
    imports: [CommonModule, UtilsModule],
    declarations: [],
    exports: []
})
export class InfrastructureModule {
    static forRoot(): ModuleWithProviders<InfrastructureModule> {
        return {
            ngModule: InfrastructureModule,
            providers: [
                ApiHttpClient,
                CouponsHttpClient,
            ]
        };
    }
}

//services
export { ApiHttpClient } from './services/api-http-client';
export { CouponsHttpClient } from './services/coupons-http-client';

//model
export * from './models/models.generated';
export * from './models/enums.generated';
